import { render } from "./layout.vue?vue&type=template&id=38799054&scoped=true&ts=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"

import "./layout.scss?vue&type=style&index=0&id=38799054&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38799054"]])

export default __exports__